/* FULLHED , unified analytics layer.
   Pushes every quiz + purchase-path interaction to window.dataLayer so GA4
   and Meta (via GTM or a Meta pixel bridge) can consume a single event stream. */
(function () {
  window.dataLayer = window.dataLayer || [];

  /**
   * fhTrack(event, params) , canonical event push.
   * Mirrors to gtag() and fbq() when those are present so the same call
   * feeds GA4 and Meta without duplicating instrumentation in templates.
   */
  function fhTrack(event, params) {
    var payload = Object.assign({ event: event, brand: 'FULLHED' }, params || {});
    window.dataLayer.push(payload);

    // GA4 direct bridge (no-op if gtag not loaded , GTM still gets dataLayer)
    if (typeof window.gtag === 'function') {
      window.gtag('event', event, params || {});
    }
    // Meta pixel bridge , map our funnel events to standard Meta events
    if (typeof window.fbq === 'function') {
      var metaMap = {
        fh_quiz_start: ['trackCustom', 'QuizStart'],
        fh_quiz_answer: ['trackCustom', 'QuizAnswer'],
        fh_quiz_complete: ['trackCustom', 'QuizComplete'],
        fh_shade_select: ['trackCustom', 'ShadeSelect'],
        fh_offer_select: ['trackCustom', 'OfferSelect'],
        fh_add_to_cart: ['track', 'AddToCart'],
        fh_begin_checkout: ['track', 'InitiateCheckout'],
      };
      var m = metaMap[event];
      if (m) { window.fbq(m[0], m[1], params || {}); }
    }

    if (window.FH_DEBUG) { console.log('[FH event]', event, params || {}); }
  }

  window.fhTrack = fhTrack;
})();
